module.exports = __webpack_public_path__ + "img/banner.72e7b476.png";